(function () {
  'use strict';
  const holder = 52492676727060, tier = 67787677499668, marker = '_rdc_chew_box_gift';
  const isGift = item => Number(item.variant_id) === holder && String(item.properties?.[marker]) === 'true';
  const qualifies = cart => (cart.items || []).filter(item => Number(item.variant_id) === tier)
    .reduce((sum, item) => sum + Number(item.final_line_price || 0), 0) >= 10000;
  function createController({ read, write, notify, changed }) {
    let pending = null, rerun = false, blocked = false;
    async function reconcile() {
      let cart = await read();
      let gifts = cart.items.filter(isGift);
      let modified = false;
      const eligible = qualifies(cart);
      if (!eligible) blocked = false;
      if (gifts.length && (!eligible || gifts.some(item => Number(item.final_line_price) > 0))) {
        await write('cart/update.js', { updates: Object.fromEntries(gifts.map(item => [item.key, 0])) });
        modified = true;
        if (eligible) {
          blocked = true;
          notify('Your free holder could not be applied. We removed it so you will not be charged. Please contact us for help.');
        }
      } else if (gifts.reduce((sum, item) => sum + item.quantity, 0) > 1) {
        await write('cart/update.js', { updates: Object.fromEntries(gifts.map((item, index) => [item.key, index ? 0 : 1])) });
        modified = true;
      } else if (eligible && !blocked && !cart.items.some(item => Number(item.variant_id) === holder)) {
        await write('cart/add.js', { items: [{ id: holder, quantity: 1, properties: { [marker]: 'true' } }] });
        modified = true;
        cart = await read();
        gifts = cart.items.filter(isGift);
        if (!qualifies(cart) || !gifts.length || gifts.some(item => Number(item.final_line_price) > 0)) {
          if (gifts.length) await write('cart/update.js', { updates: Object.fromEntries(gifts.map(item => [item.key, 0])) });
          if (qualifies(cart)) {
            blocked = true;
            notify('Your free holder could not be applied. We removed it so you will not be charged. Please contact us for help.');
          }
        }
      }
      if (modified) await changed();
    }
    function sync() {
      rerun = true;
      if (pending) return pending;
      pending = (async () => {
        while (rerun) {
          rerun = false;
          await reconcile();
        }
      })().finally(() => { pending = null; });
      return pending;
    }
    return { sync };
  }
  if (typeof module === 'object' && module.exports) {
    module.exports = { qualifies, isGift, createController };
    return;
  }
  if (window.RdcChewHolder) return;
  const root = window.Shopify?.routes?.root || '/';
  function notify(message) {
    let el = document.querySelector('[data-rdc-gift-alert]');
    if (!el) {
      el = document.createElement('p');
      el.dataset.rdcGiftAlert = '';
      el.setAttribute('role', 'alert');
      el.style.cssText = 'padding:12px;background:#f7f5ee;color:#33402f;border:1px solid #c37535';
      (document.querySelector('cart-drawer [slot="footer"]') || document.querySelector('main') || document.body).prepend(el);
    }
    el.textContent = message;
  }
  async function read() {
    const response = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
    if (!response.ok) throw Error('We could not check your free holder. Please refresh your cart before checkout.');
    return response.json();
  }
  async function write(path, data) {
    if (window.Shopify?.actions?.updateCart) {
      const lines = path === 'cart/add.js'
        ? data.items.map(item => ({ merchandiseId: String(item.id), quantity: item.quantity, attributes: Object.entries(item.properties || {}).map(([key, value]) => ({ key, value: String(value) })) }))
        : Object.entries(data.updates).map(([id, quantity]) => ({ id, quantity }));
      const result = await window.Shopify.actions.updateCart({ lines });
      if (result.userErrors?.length) throw Error('We could not update your free holder. Please refresh your cart before checkout.');
      return result;
    }
    const response = await fetch(root + path, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data) });
    if (!response.ok) throw Error('We could not update your free holder. Please refresh your cart before checkout.');
    return response.json();
  }
  const controller = createController({ read, write, notify, changed: async () => {
    if (window.themeVariables?.settings?.pageType === 'cart') {
      location.reload();
      return;
    }
    document.dispatchEvent(new CustomEvent('cart:refresh'));
    setTimeout(() => document.dispatchEvent(new CustomEvent('cart:refresh')), 1600);
  } });
  window.RdcChewHolder = controller;

  function startSubscriptionGiftCleanup() {
    const holderVariant = 52492676727060;
    const subscriptionVariants = new Set([67923796099348, 67923796132116, 67923796164884, 67923796197652, 67923796689172, 67923796721940]);
    const markerPrefix = 'rdc-subscription-holder-gift:';
    const routeRoot = window.Shopify?.routes?.root || '/';
    let running = false;

    function signature(properties) {
      const values = properties || {};
      return JSON.stringify(Object.keys(values).sort().map(key => [key, String(values[key])]));
    }

    async function sync() {
      if (running) return;
      running = true;
      try {
        const response = await fetch(routeRoot + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) return;
        const cart = await response.json();
        if (!cart.token) return;

        const markerKey = markerPrefix + String(cart.token);
        const items = cart.items || [];
        const hasSubscription = items.some(item =>
          subscriptionVariants.has(Number(item.variant_id)) && Boolean(item.selling_plan_allocation)
        );
        const freeHolder = items.find(item =>
          Number(item.variant_id) === holderVariant && Number(item.final_line_price) === 0
        );

        if (hasSubscription && freeHolder) {
          sessionStorage.setItem(markerKey, JSON.stringify({
            key: freeHolder.key,
            properties: signature(freeHolder.properties),
            quantity: 1
          }));
          return;
        }

        const saved = sessionStorage.getItem(markerKey);
        if (!hasSubscription && saved) {
          let gift;
          try {
            const marker = JSON.parse(saved);
            gift = items.find(item =>
              Number(item.variant_id) === holderVariant &&
              (item.key === marker.key || signature(item.properties) === marker.properties)
            );
            if (!gift) {
              sessionStorage.removeItem(markerKey);
              return;
            }
            const nextQuantity = Math.max(0, Number(gift.quantity || 0) - Number(marker.quantity || 1));
            sessionStorage.removeItem(markerKey);
            const update = await fetch(routeRoot + 'cart/update.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: { [gift.key]: nextQuantity } })
            });
            if (!update.ok) {
              sessionStorage.setItem(markerKey, saved);
              return;
            }
            if (window.themeVariables?.settings?.pageType === 'cart') {
              location.reload();
            } else {
              document.dispatchEvent(new CustomEvent('cart:refresh'));
              setTimeout(() => document.dispatchEvent(new CustomEvent('cart:refresh')), 500);
            }
          } catch (_) {
            sessionStorage.removeItem(markerKey);
          }
        }
      } catch (_) {
        // Leave the cart untouched if Shopify's cart endpoint is temporarily unavailable.
      } finally {
        running = false;
      }
    }

    const queueSync = () => sync();
    document.addEventListener('cart:change', queueSync);
    document.addEventListener('variant:add', queueSync);
    document.addEventListener('shopify:cart:lines-update', queueSync);
    document.addEventListener('shopify:cart:discount-update', queueSync);
    document.addEventListener('cart:refresh', queueSync);
    window.addEventListener('pageshow', queueSync);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', queueSync, { once: true });
    } else {
      queueSync();
    }
  }
  startSubscriptionGiftCleanup();
  controller.verifyCheckout = async () => {
    await controller.sync();
    const cart = await read();
    if (qualifies(cart) && !cart.items.some(item => Number(item.variant_id) === holder && Number(item.final_price) === 0)) {
      throw Error('Your free holder has not applied yet. Please refresh your cart or contact us before checkout.');
    }
  };
  const update = () => controller.sync().catch(error => notify(error.message));
  document.addEventListener('cart:change', update);
  document.addEventListener('variant:add', update);
  document.addEventListener('shopify:cart:lines-update', update);
  document.addEventListener('shopify:cart:discount-update', update);
  window.addEventListener('pageshow', update);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, { once: true });
  else update();
})();
